const ExperienceData = [
  {
    title: "Full Stack Developer Intern",
    company: "Infosys springborad",
    duration: "Dec 2024 - Feb 2025",
    description: [
      "Actively collaborating on cross-functional projects",
      "Gaining expertise in various technologies",
      "Developed Quick park assist website for ease parking facilities"
    ],
  },
  {
    title: "Frontend Developer Intern",
    company: "Suvoida Foundation",
    duration: "Nov 2024 - Dec 2024",
    description: [
      "Led a team to deliver an advanced offer letter generation portal",
      "Contributed to social work through internship"
      
    ],
  },
];

export default ExperienceData;
